export enum Action {
  NEW_OPPORTUNITY = "new_opportunity",
  AUTOMATIC_EMAIL = "automatic_email",
  CASCADE_ASSIGNMENT = "cascade_assignment",
}
